"use client";

import {JSX, ReactNode} from "react";

import Image from "next/image";

import {Drawer} from "@/shared/ui/overlay/drawer";
import {getStaticPathIcon} from "@/shared/utils/get-static-path-icon";

import "./styles/search-drawer.scss";

export interface SearchDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
    footer?: ReactNode;
    className?: string;
}

export function SearchDrawer({isOpen, onClose, children, footer, className}: SearchDrawerProps): JSX.Element {
    return (
        <Drawer
            open={isOpen}
            onClose={onClose}
            direction="bottom"
            size="100%"
            zIndex={9999}
            borderRadius={0}
            overlayOpacity={0.5}
            className={`search-drawer ${className || ""}`}
        >
            <div className="search-drawer__header">
                <button type="button" className="search-drawer__close" onClick={onClose} aria-label="Close">
                    <Image src={getStaticPathIcon("close-simple")} alt="" width={14} height={14} />
                </button>
            </div>
            <div className="search-drawer__body">{children}</div>
            {footer && <div className="search-drawer__footer">{footer}</div>}
        </Drawer>
    );
}
